export const eclipseTheme = {
  eclipseTier1: {
    typography: {
      fontFamily: {
        inter: 'var(--eclipse-tier1-typography-font-family-inter)',
      },
      fontWeight: {
        regular: 'var(--eclipse-tier1-typography-font-weight-regular)',
        medium: 'var(--eclipse-tier1-typography-font-weight-medium)',
        semibold: 'var(--eclipse-tier1-typography-font-weight-semibold)',
      },
      fontSize: {
        '12': 'var(--eclipse-tier1-typography-font-size-12)',
        '14': 'var(--eclipse-tier1-typography-font-size-14)',
        '16': 'var(--eclipse-tier1-typography-font-size-16)',
        '24': 'var(--eclipse-tier1-typography-font-size-24)',
        '32': 'var(--eclipse-tier1-typography-font-size-32)',
        '44': 'var(--eclipse-tier1-typography-font-size-44)',
      },
      lineHeight: {
        '16': 'var(--eclipse-tier1-typography-line-height-16)',
        '20': 'var(--eclipse-tier1-typography-line-height-20)',
        '24': 'var(--eclipse-tier1-typography-line-height-24)',
        '32': 'var(--eclipse-tier1-typography-line-height-32)',
        '40': 'var(--eclipse-tier1-typography-line-height-40)',
        '52': 'var(--eclipse-tier1-typography-line-height-52)',
      },
    },
    color: {
      white: 'var(--eclipse-tier1-color-white)',
      black: 'var(--eclipse-tier1-color-black)',
      transparency: {
        '0': 'var(--eclipse-tier1-color-transparency-0)',
        balticSea: {
          '70-30': 'var(--eclipse-tier1-color-transparency-baltic-sea-7030)',
          '80-50': 'var(--eclipse-tier1-color-transparency-baltic-sea-8050)',
          '100-50': 'var(--eclipse-tier1-color-transparency-baltic-sea-10050)',
          '110-10': 'var(--eclipse-tier1-color-transparency-baltic-sea-11010)',
          '110-40': 'var(--eclipse-tier1-color-transparency-baltic-sea-11040)',
          '110-60': 'var(--eclipse-tier1-color-transparency-baltic-sea-11060)',
        },
      },
      indigo: {
        '10': 'var(--eclipse-tier1-color-indigo-10)',
        '20': 'var(--eclipse-tier1-color-indigo-20)',
        '30': 'var(--eclipse-tier1-color-indigo-30)',
        '40': 'var(--eclipse-tier1-color-indigo-40)',
        '50': 'var(--eclipse-tier1-color-indigo-50)',
        '60': 'var(--eclipse-tier1-color-indigo-60)',
        '70': 'var(--eclipse-tier1-color-indigo-70)',
        '80': 'var(--eclipse-tier1-color-indigo-80)',
        '90': 'var(--eclipse-tier1-color-indigo-90)',
        '100': 'var(--eclipse-tier1-color-indigo-100)',
      },
      balticSea: {
        '10': 'var(--eclipse-tier1-color-baltic-sea-10)',
        '20': 'var(--eclipse-tier1-color-baltic-sea-20)',
        '30': 'var(--eclipse-tier1-color-baltic-sea-30)',
        '40': 'var(--eclipse-tier1-color-baltic-sea-40)',
        '50': 'var(--eclipse-tier1-color-baltic-sea-50)',
        '60': 'var(--eclipse-tier1-color-baltic-sea-60)',
        '70': 'var(--eclipse-tier1-color-baltic-sea-70)',
        '80': 'var(--eclipse-tier1-color-baltic-sea-80)',
        '85': 'var(--eclipse-tier1-color-baltic-sea-85)',
        '90': 'var(--eclipse-tier1-color-baltic-sea-90)',
        '100': 'var(--eclipse-tier1-color-baltic-sea-100)',
        '105': 'var(--eclipse-tier1-color-baltic-sea-105)',
        '110': 'var(--eclipse-tier1-color-baltic-sea-110)',
      },
      chili: {
        '10': 'var(--eclipse-tier1-color-chili-10)',
        '20': 'var(--eclipse-tier1-color-chili-20)',
        '30': 'var(--eclipse-tier1-color-chili-30)',
        '40': 'var(--eclipse-tier1-color-chili-40)',
        '50': 'var(--eclipse-tier1-color-chili-50)',
      },
      mango: {
        '10': 'var(--eclipse-tier1-color-mango-10)',
        '20': 'var(--eclipse-tier1-color-mango-20)',
        '30': 'var(--eclipse-tier1-color-mango-30)',
        '40': 'var(--eclipse-tier1-color-mango-40)',
        '50': 'var(--eclipse-tier1-color-mango-50)',
      },
      seaweed: {
        '10': 'var(--eclipse-tier1-color-seaweed-10)',
        '20': 'var(--eclipse-tier1-color-seaweed-20)',
        '30': 'var(--eclipse-tier1-color-seaweed-30)',
        '40': 'var(--eclipse-tier1-color-seaweed-40)',
        '50': 'var(--eclipse-tier1-color-seaweed-50)',
      },
      focusBlue: {
        '10': 'var(--eclipse-tier1-color-focus-blue-10)',
        '20': 'var(--eclipse-tier1-color-focus-blue-20)',
      },
      infoBlue: {
        '10': 'var(--eclipse-tier1-color-info-blue-10)',
        '20': 'var(--eclipse-tier1-color-info-blue-20)',
        '30': 'var(--eclipse-tier1-color-info-blue-30)',
        '40': 'var(--eclipse-tier1-color-info-blue-40)',
        '50': 'var(--eclipse-tier1-color-info-blue-50)',
      },
      lavender: {
        '10': 'var(--eclipse-tier1-color-lavender-10)',
        '20': 'var(--eclipse-tier1-color-lavender-20)',
        '30': 'var(--eclipse-tier1-color-lavender-30)',
        '40': 'var(--eclipse-tier1-color-lavender-40)',
        '50': 'var(--eclipse-tier1-color-lavender-50)',
      },
      seafoam: {
        '10': 'var(--eclipse-tier1-color-seafoam-10)',
        '20': 'var(--eclipse-tier1-color-seafoam-20)',
        '30': 'var(--eclipse-tier1-color-seafoam-30)',
        '40': 'var(--eclipse-tier1-color-seafoam-40)',
        '50': 'var(--eclipse-tier1-color-seafoam-50)',
      },
      tangerine: {
        '10': 'var(--eclipse-tier1-color-tangerine-10)',
        '20': 'var(--eclipse-tier1-color-tangerine-20)',
        '30': 'var(--eclipse-tier1-color-tangerine-30)',
        '40': 'var(--eclipse-tier1-color-tangerine-40)',
        '50': 'var(--eclipse-tier1-color-tangerine-50)',
      },
      cornflower: {
        '10': 'var(--eclipse-tier1-color-cornflower-10)',
        '20': 'var(--eclipse-tier1-color-cornflower-20)',
        '30': 'var(--eclipse-tier1-color-cornflower-30)',
        '40': 'var(--eclipse-tier1-color-cornflower-40)',
        '50': 'var(--eclipse-tier1-color-cornflower-50)',
      },
      hibiscus: {
        '10': 'var(--eclipse-tier1-color-hibiscus-10)',
        '20': 'var(--eclipse-tier1-color-hibiscus-20)',
        '30': 'var(--eclipse-tier1-color-hibiscus-30)',
        '40': 'var(--eclipse-tier1-color-hibiscus-40)',
        '50': 'var(--eclipse-tier1-color-hibiscus-50)',
      },
      lime: {
        '10': 'var(--eclipse-tier1-color-lime-10)',
        '20': 'var(--eclipse-tier1-color-lime-20)',
        '30': 'var(--eclipse-tier1-color-lime-30)',
        '40': 'var(--eclipse-tier1-color-lime-40)',
        '50': 'var(--eclipse-tier1-color-lime-50)',
      },
    },
    spacing: {
      '0px': 'var(--eclipse-tier1-spacing-0px)',
      '2px': 'var(--eclipse-tier1-spacing-2px)',
      '4px': 'var(--eclipse-tier1-spacing-4px)',
      '8px': 'var(--eclipse-tier1-spacing-8px)',
      '12px': 'var(--eclipse-tier1-spacing-12px)',
      '16px': 'var(--eclipse-tier1-spacing-16px)',
      '20px': 'var(--eclipse-tier1-spacing-20px)',
      '24px': 'var(--eclipse-tier1-spacing-24px)',
      '32px': 'var(--eclipse-tier1-spacing-32px)',
      '40px': 'var(--eclipse-tier1-spacing-40px)',
      '48px': 'var(--eclipse-tier1-spacing-48px)',
      '64px': 'var(--eclipse-tier1-spacing-64px)',
    },
    sizing: {
      '8px': 'var(--eclipse-tier1-sizing-8px)',
      '12px': 'var(--eclipse-tier1-sizing-12px)',
      '14px': 'var(--eclipse-tier1-sizing-14px)',
      '16px': 'var(--eclipse-tier1-sizing-16px)',
      '20px': 'var(--eclipse-tier1-sizing-20px)',
      '24px': 'var(--eclipse-tier1-sizing-24px)',
      '28px': 'var(--eclipse-tier1-sizing-28px)',
      '36px': 'var(--eclipse-tier1-sizing-36px)',
      '40px': 'var(--eclipse-tier1-sizing-40px)',
      '48px': 'var(--eclipse-tier1-sizing-48px)',
      '64px': 'var(--eclipse-tier1-sizing-64px)',
      '80px': 'var(--eclipse-tier1-sizing-80px)',
      '112px': 'var(--eclipse-tier1-sizing-112px)',
    },
    radius: {
      '0px': 'var(--eclipse-tier1-radius-0px)',
      '2px': 'var(--eclipse-tier1-radius-2px)',
      '4px': 'var(--eclipse-tier1-radius-4px)',
      '8px': 'var(--eclipse-tier1-radius-8px)',
      '12px': 'var(--eclipse-tier1-radius-12px)',
      '16px': 'var(--eclipse-tier1-radius-16px)',
      '20px': 'var(--eclipse-tier1-radius-20px)',
      '9999px': 'var(--eclipse-tier1-radius-9999px)',
    },
    breakpoints: {
      width: {
        min: {
          xs: 0,
          sm: 576,
          md: 768,
          lg: 1024,
          xl: 1440,
        },
        max: {
          xs: 575,
          sm: 767,
          md: 1023,
          lg: 1439,
          xl: 1920,
        },
      },
    },
    borderWidth: {
      '1px': 'var(--eclipse-tier1-border-width-1px)',
      '2px': 'var(--eclipse-tier1-border-width-2px)',
    },
  },
  eclipseTier2Border: {
    width: {
      default: 'var(--eclipse-tier2-border-width-default)',
      emphasis: 'var(--eclipse-tier2-border-width-emphasis)',
      selected: 'var(--eclipse-tier2-border-width-selected)',
      focused: 'var(--eclipse-tier2-border-width-focused)',
    },
  },
  eclipseTier2Color: {
    text: {
      default: 'var(--eclipse-tier2-color-text-default)',
      subtle: 'var(--eclipse-tier2-color-text-subtle)',
      subtlest: 'var(--eclipse-tier2-color-text-subtlest)',
      inverse: 'var(--eclipse-tier2-color-text-inverse)',
      warningInverse: 'var(--eclipse-tier2-color-text-warning-inverse)',
      selected: 'var(--eclipse-tier2-color-text-selected)',
      disabled: 'var(--eclipse-tier2-color-text-disabled)',
      brand: {
        default: 'var(--eclipse-tier2-color-text-brand-default)',
        hovered: 'var(--eclipse-tier2-color-text-brand-hovered)',
        pressed: 'var(--eclipse-tier2-color-text-brand-pressed)',
        visited: 'var(--eclipse-tier2-color-text-brand-visited)',
      },
      error: {
        default: 'var(--eclipse-tier2-color-text-error-default)',
        onSubtle: 'var(--eclipse-tier2-color-text-error-on-subtle)',
      },
      warning: {
        default: 'var(--eclipse-tier2-color-text-warning-default)',
        onSubtle: 'var(--eclipse-tier2-color-text-warning-on-subtle)',
      },
      success: {
        default: 'var(--eclipse-tier2-color-text-success-default)',
        onSubtle: 'var(--eclipse-tier2-color-text-success-on-subtle)',
      },
      info: {
        default: 'var(--eclipse-tier2-color-text-info-default)',
        onSubtle: 'var(--eclipse-tier2-color-text-info-on-subtle)',
      },
      accent: {
        '1': {
          default: 'var(--eclipse-tier2-color-text-accent-1-default)',
          onSubtle: 'var(--eclipse-tier2-color-text-accent-1-on-subtle)',
        },
        '2': {
          default: 'var(--eclipse-tier2-color-text-accent-2-default)',
          onSubtle: 'var(--eclipse-tier2-color-text-accent-2-on-subtle)',
        },
        '3': {
          default: 'var(--eclipse-tier2-color-text-accent-3-default)',
          onSubtle: 'var(--eclipse-tier2-color-text-accent-3-on-subtle)',
        },
        '4': {
          default: 'var(--eclipse-tier2-color-text-accent-4-default)',
          onSubtle: 'var(--eclipse-tier2-color-text-accent-4-on-subtle)',
        },
        '5': {
          default: 'var(--eclipse-tier2-color-text-accent-5-default)',
          onSubtle: 'var(--eclipse-tier2-color-text-accent-5-on-subtle)',
        },
        '6': {
          default: 'var(--eclipse-tier2-color-text-accent-6-default)',
          onSubtle: 'var(--eclipse-tier2-color-text-accent-6-on-subtle)',
        },
      },
    },
    border: {
      bold: 'var(--eclipse-tier2-color-border-bold)',
      subtle: 'var(--eclipse-tier2-color-border-subtle)',
      selected: 'var(--eclipse-tier2-color-border-selected)',
      focus: 'var(--eclipse-tier2-color-border-focus)',
      disabled: 'var(--eclipse-tier2-color-border-disabled)',
      input: 'var(--eclipse-tier2-color-border-input)',
      error: 'var(--eclipse-tier2-color-border-error)',
      warning: 'var(--eclipse-tier2-color-border-warning)',
      success: 'var(--eclipse-tier2-color-border-success)',
      info: 'var(--eclipse-tier2-color-border-info)',
      nav: {
        bold: 'var(--eclipse-tier2-color-border-nav-bold)',
        subtle: 'var(--eclipse-tier2-color-border-nav-subtle)',
      },
      brand: {
        default: 'var(--eclipse-tier2-color-border-brand-default)',
        hovered: 'var(--eclipse-tier2-color-border-brand-hovered)',
        pressed: 'var(--eclipse-tier2-color-border-brand-pressed)',
      },
      accent: {
        '1': 'var(--eclipse-tier2-color-border-accent-1)',
        '2': 'var(--eclipse-tier2-color-border-accent-2)',
        '3': 'var(--eclipse-tier2-color-border-accent-3)',
        '4': 'var(--eclipse-tier2-color-border-accent-4)',
        '5': 'var(--eclipse-tier2-color-border-accent-5)',
        '6': 'var(--eclipse-tier2-color-border-accent-6)',
      },
    },
    background: {
      input: 'var(--eclipse-tier2-color-background-input)',
      image: {
        hovered: 'var(--eclipse-tier2-color-background-image-hovered)',
      },
      disabled: {
        default: 'var(--eclipse-tier2-color-background-disabled-default)',
        subtle: 'var(--eclipse-tier2-color-background-disabled-subtle)',
      },
      neutral: {
        bold: {
          default: 'var(--eclipse-tier2-color-background-neutral-bold-default)',
          hovered: 'var(--eclipse-tier2-color-background-neutral-bold-hovered)',
          pressed: 'var(--eclipse-tier2-color-background-neutral-bold-pressed)',
        },
        subtle: {
          default: 'var(--eclipse-tier2-color-background-neutral-subtle-default)',
          hovered: 'var(--eclipse-tier2-color-background-neutral-subtle-hovered)',
          selected: 'var(--eclipse-tier2-color-background-neutral-subtle-selected)',
        },
        subtlest: {
          default: 'var(--eclipse-tier2-color-background-neutral-subtlest-default)',
          hovered: 'var(--eclipse-tier2-color-background-neutral-subtlest-hovered)',
          selected: 'var(--eclipse-tier2-color-background-neutral-subtlest-selected)',
        },
      },
      nav: {
        default: 'var(--eclipse-tier2-color-background-nav-default)',
        expanded: 'var(--eclipse-tier2-color-background-nav-expanded)',
        hovered: 'var(--eclipse-tier2-color-background-nav-hovered)',
        selected: 'var(--eclipse-tier2-color-background-nav-selected)',
      },
      brand: {
        bold: {
          default: 'var(--eclipse-tier2-color-background-brand-bold-default)',
          hovered: 'var(--eclipse-tier2-color-background-brand-bold-hovered)',
          pressed: 'var(--eclipse-tier2-color-background-brand-bold-pressed)',
        },
        subtle: {
          default: 'var(--eclipse-tier2-color-background-brand-subtle-default)',
          hovered: 'var(--eclipse-tier2-color-background-brand-subtle-hovered)',
          pressed: 'var(--eclipse-tier2-color-background-brand-subtle-pressed)',
        },
      },
      error: {
        subtle: 'var(--eclipse-tier2-color-background-error-subtle)',
        bold: {
          default: 'var(--eclipse-tier2-color-background-error-bold-default)',
          hovered: 'var(--eclipse-tier2-color-background-error-bold-hovered)',
          pressed: 'var(--eclipse-tier2-color-background-error-bold-pressed)',
        },
      },
      warning: {
        subtle: 'var(--eclipse-tier2-color-background-warning-subtle)',
        bold: {
          default: 'var(--eclipse-tier2-color-background-warning-bold-default)',
          hovered: 'var(--eclipse-tier2-color-background-warning-bold-hovered)',
          pressed: 'var(--eclipse-tier2-color-background-warning-bold-pressed)',
        },
      },
      success: {
        subtle: 'var(--eclipse-tier2-color-background-success-subtle)',
        bold: {
          default: 'var(--eclipse-tier2-color-background-success-bold-default)',
          hovered: 'var(--eclipse-tier2-color-background-success-bold-hovered)',
          pressed: 'var(--eclipse-tier2-color-background-success-bold-pressed)',
        },
      },
      info: {
        subtle: 'var(--eclipse-tier2-color-background-info-subtle)',
        bold: {
          default: 'var(--eclipse-tier2-color-background-info-bold-default)',
          hovered: 'var(--eclipse-tier2-color-background-info-bold-hovered)',
          pressed: 'var(--eclipse-tier2-color-background-info-bold-pressed)',
        },
      },
      accent: {
        '1': {
          subtle: 'var(--eclipse-tier2-color-background-accent-1-subtle)',
          bold: {
            default: 'var(--eclipse-tier2-color-background-accent-1-bold-default)',
            hovered: 'var(--eclipse-tier2-color-background-accent-1-bold-hovered)',
          },
        },
        '2': {
          subtle: 'var(--eclipse-tier2-color-background-accent-2-subtle)',
          bold: {
            default: 'var(--eclipse-tier2-color-background-accent-2-bold-default)',
            hovered: 'var(--eclipse-tier2-color-background-accent-2-bold-hovered)',
          },
        },
        '3': {
          subtle: 'var(--eclipse-tier2-color-background-accent-3-subtle)',
          bold: {
            default: 'var(--eclipse-tier2-color-background-accent-3-bold-default)',
            hovered: 'var(--eclipse-tier2-color-background-accent-3-bold-hovered)',
          },
        },
        '4': {
          subtle: 'var(--eclipse-tier2-color-background-accent-4-subtle)',
          bold: {
            default: 'var(--eclipse-tier2-color-background-accent-4-bold-default)',
            hovered: 'var(--eclipse-tier2-color-background-accent-4-bold-hovered)',
          },
        },
        '5': {
          subtle: 'var(--eclipse-tier2-color-background-accent-5-subtle)',
          bold: {
            default: 'var(--eclipse-tier2-color-background-accent-5-bold-default)',
            hovered: 'var(--eclipse-tier2-color-background-accent-5-bold-hovered)',
          },
        },
        '6': {
          subtle: 'var(--eclipse-tier2-color-background-accent-6-subtle)',
          bold: {
            default: 'var(--eclipse-tier2-color-background-accent-6-bold-default)',
            hovered: 'var(--eclipse-tier2-color-background-accent-6-bold-hovered)',
          },
        },
      },
      chart: {
        single: 'var(--eclipse-tier2-color-background-chart-single)',
        categorical: {
          '1': 'var(--eclipse-tier2-color-background-chart-categorical-1)',
          '2': 'var(--eclipse-tier2-color-background-chart-categorical-2)',
          '3': 'var(--eclipse-tier2-color-background-chart-categorical-3)',
          '4': 'var(--eclipse-tier2-color-background-chart-categorical-4)',
          '5': 'var(--eclipse-tier2-color-background-chart-categorical-5)',
          '6': 'var(--eclipse-tier2-color-background-chart-categorical-6)',
          '7': 'var(--eclipse-tier2-color-background-chart-categorical-7)',
          '8': 'var(--eclipse-tier2-color-background-chart-categorical-8)',
          '9': 'var(--eclipse-tier2-color-background-chart-categorical-9)',
          '10': 'var(--eclipse-tier2-color-background-chart-categorical-10)',
          '11': 'var(--eclipse-tier2-color-background-chart-categorical-11)',
          '12': 'var(--eclipse-tier2-color-background-chart-categorical-12)',
        },
        sequential: {
          '1': 'var(--eclipse-tier2-color-background-chart-sequential-1)',
          '2': 'var(--eclipse-tier2-color-background-chart-sequential-2)',
          '3': 'var(--eclipse-tier2-color-background-chart-sequential-3)',
          '4': 'var(--eclipse-tier2-color-background-chart-sequential-4)',
          '5': 'var(--eclipse-tier2-color-background-chart-sequential-5)',
        },
      },
    },
    surface: {
      sunken: 'var(--eclipse-tier2-color-surface-sunken)',
      base: 'var(--eclipse-tier2-color-surface-base)',
      raised: 'var(--eclipse-tier2-color-surface-raised)',
      structure: 'var(--eclipse-tier2-color-surface-structure)',
      overlay: 'var(--eclipse-tier2-color-surface-overlay)',
      modal: 'var(--eclipse-tier2-color-surface-modal)',
      elevation: {
        blanket: 'var(--eclipse-tier2-color-surface-elevation-blanket)',
        shadow: {
          raised: {
            key: {
              x: 'var(--eclipse-tier2-color-surface-elevation-shadow-raised-key-x)',
              y: 'var(--eclipse-tier2-color-surface-elevation-shadow-raised-key-y)',
              blur: 'var(--eclipse-tier2-color-surface-elevation-shadow-raised-key-blur)',
              color: 'var(--eclipse-tier2-color-surface-elevation-shadow-raised-key-color)',
            },
            ambient: {
              x: 'var(--eclipse-tier2-color-surface-elevation-shadow-raised-ambient-x)',
              y: 'var(--eclipse-tier2-color-surface-elevation-shadow-raised-ambient-y)',
              blur: 'var(--eclipse-tier2-color-surface-elevation-shadow-raised-ambient-blur)',
              color: 'var(--eclipse-tier2-color-surface-elevation-shadow-raised-ambient-color)',
            },
            boxShadow:
              'var(--eclipse-tier2-color-surface-elevation-shadow-raised-key-x) var(--eclipse-tier2-color-surface-elevation-shadow-raised-key-y) var(--eclipse-tier2-color-surface-elevation-shadow-raised-key-blur) var(--eclipse-tier2-color-surface-elevation-shadow-raised-key-color), var(--eclipse-tier2-color-surface-elevation-shadow-raised-ambient-x) var(--eclipse-tier2-color-surface-elevation-shadow-raised-ambient-y) var(--eclipse-tier2-color-surface-elevation-shadow-raised-ambient-blur) var(--eclipse-tier2-color-surface-elevation-shadow-raised-ambient-color)',
            dropShadow:
              'drop-shadow(var(--eclipse-tier2-color-surface-elevation-shadow-raised-key-x) var(--eclipse-tier2-color-surface-elevation-shadow-raised-key-y) var(--eclipse-tier2-color-surface-elevation-shadow-raised-key-blur) var(--eclipse-tier2-color-surface-elevation-shadow-raised-key-color)) drop-shadow(var(--eclipse-tier2-color-surface-elevation-shadow-raised-ambient-x) var(--eclipse-tier2-color-surface-elevation-shadow-raised-ambient-y) var(--eclipse-tier2-color-surface-elevation-shadow-raised-ambient-blur) var(--eclipse-tier2-color-surface-elevation-shadow-raised-ambient-color))',
          },
          overlay: {
            key: {
              x: 'var(--eclipse-tier2-color-surface-elevation-shadow-overlay-key-x)',
              y: 'var(--eclipse-tier2-color-surface-elevation-shadow-overlay-key-y)',
              blur: 'var(--eclipse-tier2-color-surface-elevation-shadow-overlay-key-blur)',
              color: 'var(--eclipse-tier2-color-surface-elevation-shadow-overlay-key-color)',
            },
            ambient: {
              x: 'var(--eclipse-tier2-color-surface-elevation-shadow-overlay-ambient-x)',
              y: 'var(--eclipse-tier2-color-surface-elevation-shadow-overlay-ambient-y)',
              blur: 'var(--eclipse-tier2-color-surface-elevation-shadow-overlay-ambient-blur)',
              color: 'var(--eclipse-tier2-color-surface-elevation-shadow-overlay-ambient-color)',
            },
            boxShadow:
              'var(--eclipse-tier2-color-surface-elevation-shadow-overlay-key-x) var(--eclipse-tier2-color-surface-elevation-shadow-overlay-key-y) var(--eclipse-tier2-color-surface-elevation-shadow-overlay-key-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overlay-key-color), var(--eclipse-tier2-color-surface-elevation-shadow-overlay-ambient-x) var(--eclipse-tier2-color-surface-elevation-shadow-overlay-ambient-y) var(--eclipse-tier2-color-surface-elevation-shadow-overlay-ambient-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overlay-ambient-color)',
            dropShadow:
              'drop-shadow(var(--eclipse-tier2-color-surface-elevation-shadow-overlay-key-x) var(--eclipse-tier2-color-surface-elevation-shadow-overlay-key-y) var(--eclipse-tier2-color-surface-elevation-shadow-overlay-key-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overlay-key-color)) drop-shadow(var(--eclipse-tier2-color-surface-elevation-shadow-overlay-ambient-x) var(--eclipse-tier2-color-surface-elevation-shadow-overlay-ambient-y) var(--eclipse-tier2-color-surface-elevation-shadow-overlay-ambient-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overlay-ambient-color))',
          },
          modal: {
            key: {
              x: 'var(--eclipse-tier2-color-surface-elevation-shadow-modal-key-x)',
              y: 'var(--eclipse-tier2-color-surface-elevation-shadow-modal-key-y)',
              blur: 'var(--eclipse-tier2-color-surface-elevation-shadow-modal-key-blur)',
              color: 'var(--eclipse-tier2-color-surface-elevation-shadow-modal-key-color)',
            },
            ambient: {
              x: 'var(--eclipse-tier2-color-surface-elevation-shadow-modal-ambient-x)',
              y: 'var(--eclipse-tier2-color-surface-elevation-shadow-modal-ambient-y)',
              blur: 'var(--eclipse-tier2-color-surface-elevation-shadow-modal-ambient-blur)',
              color: 'var(--eclipse-tier2-color-surface-elevation-shadow-modal-ambient-color)',
            },
            boxShadow:
              'var(--eclipse-tier2-color-surface-elevation-shadow-modal-key-x) var(--eclipse-tier2-color-surface-elevation-shadow-modal-key-y) var(--eclipse-tier2-color-surface-elevation-shadow-modal-key-blur) var(--eclipse-tier2-color-surface-elevation-shadow-modal-key-color), var(--eclipse-tier2-color-surface-elevation-shadow-modal-ambient-x) var(--eclipse-tier2-color-surface-elevation-shadow-modal-ambient-y) var(--eclipse-tier2-color-surface-elevation-shadow-modal-ambient-blur) var(--eclipse-tier2-color-surface-elevation-shadow-modal-ambient-color)',
            dropShadow:
              'drop-shadow(var(--eclipse-tier2-color-surface-elevation-shadow-modal-key-x) var(--eclipse-tier2-color-surface-elevation-shadow-modal-key-y) var(--eclipse-tier2-color-surface-elevation-shadow-modal-key-blur) var(--eclipse-tier2-color-surface-elevation-shadow-modal-key-color)) drop-shadow(var(--eclipse-tier2-color-surface-elevation-shadow-modal-ambient-x) var(--eclipse-tier2-color-surface-elevation-shadow-modal-ambient-y) var(--eclipse-tier2-color-surface-elevation-shadow-modal-ambient-blur) var(--eclipse-tier2-color-surface-elevation-shadow-modal-ambient-color))',
          },
          overflow: {
            bottom: {
              key: {
                x: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-key-x)',
                y: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-key-y)',
                blur: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-key-blur)',
                spread: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-key-spread)',
                color: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-key-color)',
              },
              ambient: {
                x: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-ambient-x)',
                y: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-ambient-y)',
                blur: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-ambient-blur)',
                spread: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-ambient-spread)',
                color: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-ambient-color)',
              },
              boxShadow:
                'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-key-x) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-key-y) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-key-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-key-spread) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-key-color), var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-ambient-x) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-ambient-y) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-ambient-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-ambient-spread) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-ambient-color)',
              dropShadow:
                'drop-shadow(var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-key-x) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-key-y) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-key-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-key-color)) drop-shadow(var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-ambient-x) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-ambient-y) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-ambient-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-bottom-ambient-color))',
            },
            top: {
              key: {
                x: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-key-x)',
                y: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-key-y)',
                blur: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-key-blur)',
                spread: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-key-spread)',
                color: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-key-color)',
              },
              ambient: {
                x: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-ambient-x)',
                y: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-ambient-y)',
                blur: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-ambient-blur)',
                spread: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-ambient-spread)',
                color: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-ambient-color)',
              },
              boxShadow:
                'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-key-x) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-key-y) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-key-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-key-spread) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-key-color), var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-ambient-x) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-ambient-y) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-ambient-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-ambient-spread) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-ambient-color)',
              dropShadow:
                'drop-shadow(var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-key-x) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-key-y) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-key-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-key-color)) drop-shadow(var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-ambient-x) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-ambient-y) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-ambient-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-top-ambient-color))',
            },
            left: {
              key: {
                x: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-key-x)',
                y: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-key-y)',
                blur: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-key-blur)',
                spread: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-key-spread)',
                color: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-key-color)',
              },
              ambient: {
                x: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-ambient-x)',
                y: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-ambient-y)',
                blur: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-ambient-blur)',
                spread: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-ambient-spread)',
                color: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-ambient-color)',
              },
              boxShadow:
                'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-key-x) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-key-y) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-key-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-key-spread) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-key-color), var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-ambient-x) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-ambient-y) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-ambient-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-ambient-spread) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-ambient-color)',
              dropShadow:
                'drop-shadow(var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-key-x) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-key-y) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-key-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-key-color)) drop-shadow(var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-ambient-x) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-ambient-y) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-ambient-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-left-ambient-color))',
            },
            right: {
              key: {
                x: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-key-x)',
                y: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-key-y)',
                blur: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-key-blur)',
                spread: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-key-spread)',
                color: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-key-color)',
              },
              ambient: {
                x: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-ambient-x)',
                y: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-ambient-y)',
                blur: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-ambient-blur)',
                spread: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-ambient-spread)',
                color: 'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-ambient-color)',
              },
              boxShadow:
                'var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-key-x) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-key-y) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-key-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-key-spread) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-key-color), var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-ambient-x) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-ambient-y) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-ambient-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-ambient-spread) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-ambient-color)',
              dropShadow:
                'drop-shadow(var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-key-x) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-key-y) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-key-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-key-color)) drop-shadow(var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-ambient-x) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-ambient-y) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-ambient-blur) var(--eclipse-tier2-color-surface-elevation-shadow-overflow-right-ambient-color))',
            },
          },
        },
      },
    },
    skeleton: {
      default: 'var(--eclipse-tier2-color-skeleton-default)',
      shimmer: 'var(--eclipse-tier2-color-skeleton-shimmer)',
    },
  },
  eclipseTier2Typography: {
    display: {
      fontFamily: 'var(--eclipse-tier2-typography-display-font-family)',
      fontWeight: 'var(--eclipse-tier2-typography-display-font-weight)',
      fontSize: 'var(--eclipse-tier2-typography-display-font-size)',
      lineHeight: 'var(--eclipse-tier2-typography-display-line-height)',
    },
    title: {
      fontFamily: 'var(--eclipse-tier2-typography-title-font-family)',
      fontWeight: 'var(--eclipse-tier2-typography-title-font-weight)',
      fontSize: 'var(--eclipse-tier2-typography-title-font-size)',
      lineHeight: 'var(--eclipse-tier2-typography-title-line-height)',
    },
    headingLg: {
      fontFamily: 'var(--eclipse-tier2-typography-heading-lg-font-family)',
      fontWeight: 'var(--eclipse-tier2-typography-heading-lg-font-weight)',
      fontSize: 'var(--eclipse-tier2-typography-heading-lg-font-size)',
      lineHeight: 'var(--eclipse-tier2-typography-heading-lg-line-height)',
    },
    headingMd: {
      fontFamily: 'var(--eclipse-tier2-typography-heading-md-font-family)',
      fontWeight: 'var(--eclipse-tier2-typography-heading-md-font-weight)',
      fontSize: 'var(--eclipse-tier2-typography-heading-md-font-size)',
      lineHeight: 'var(--eclipse-tier2-typography-heading-md-line-height)',
    },
    headingMdSemibold: {
      fontFamily: 'var(--eclipse-tier2-typography-heading-md-semibold-font-family)',
      fontWeight: 'var(--eclipse-tier2-typography-heading-md-semibold-font-weight)',
      fontSize: 'var(--eclipse-tier2-typography-heading-md-semibold-font-size)',
      lineHeight: 'var(--eclipse-tier2-typography-heading-md-semibold-line-height)',
    },
    labelMd: {
      fontFamily: 'var(--eclipse-tier2-typography-label-md-font-family)',
      fontWeight: 'var(--eclipse-tier2-typography-label-md-font-weight)',
      fontSize: 'var(--eclipse-tier2-typography-label-md-font-size)',
      lineHeight: 'var(--eclipse-tier2-typography-label-md-line-height)',
    },
    labelMdSemibold: {
      fontFamily: 'var(--eclipse-tier2-typography-label-md-semibold-font-family)',
      fontWeight: 'var(--eclipse-tier2-typography-label-md-semibold-font-weight)',
      fontSize: 'var(--eclipse-tier2-typography-label-md-semibold-font-size)',
      lineHeight: 'var(--eclipse-tier2-typography-label-md-semibold-line-height)',
    },
    labelSmSemibold: {
      fontFamily: 'var(--eclipse-tier2-typography-label-sm-semibold-font-family)',
      fontWeight: 'var(--eclipse-tier2-typography-label-sm-semibold-font-weight)',
      fontSize: 'var(--eclipse-tier2-typography-label-sm-semibold-font-size)',
      lineHeight: 'var(--eclipse-tier2-typography-label-sm-semibold-line-height)',
    },
    navHeader: {
      fontFamily: 'var(--eclipse-tier2-typography-nav-header-font-family)',
      fontWeight: 'var(--eclipse-tier2-typography-nav-header-font-weight)',
      fontSize: 'var(--eclipse-tier2-typography-nav-header-font-size)',
      lineHeight: 'var(--eclipse-tier2-typography-nav-header-line-height)',
    },
    bodyMd: {
      fontFamily: 'var(--eclipse-tier2-typography-body-md-font-family)',
      fontWeight: 'var(--eclipse-tier2-typography-body-md-font-weight)',
      fontSize: 'var(--eclipse-tier2-typography-body-md-font-size)',
      lineHeight: 'var(--eclipse-tier2-typography-body-md-line-height)',
    },
    bodySm: {
      fontFamily: 'var(--eclipse-tier2-typography-body-sm-font-family)',
      fontWeight: 'var(--eclipse-tier2-typography-body-sm-font-weight)',
      fontSize: 'var(--eclipse-tier2-typography-body-sm-font-size)',
      lineHeight: 'var(--eclipse-tier2-typography-body-sm-line-height)',
    },
    link: {
      fontFamily: 'var(--eclipse-tier2-typography-link-font-family)',
      fontWeight: 'var(--eclipse-tier2-typography-link-font-weight)',
      fontSize: 'var(--eclipse-tier2-typography-link-font-size)',
      lineHeight: 'var(--eclipse-tier2-typography-link-line-height)',
    },
  },
  eclipseResponsive: {
    columns: 'var(--eclipse-responsive-columns)',
    margin: 'var(--eclipse-responsive-margin)',
    gutter: 'var(--eclipse-responsive-gutter)',
  },
};
